import {
    HeaderGroup,
    Table as TanstackTable,
    flexRender,
} from '@tanstack/react-table'
import { TableHeaderCell } from './TableHeaderCell'
import { getTableHeaderCellProps } from './utils/getTableHeaderCellProps'
import { SortingOrder } from '../SortingIconButton/SortingIconButton'
import { Table } from '../..'
import { ComponentProps } from 'react'

type TableHeaderRowProps = {
    table: TanstackTable<unknown>
    headerGroup: HeaderGroup<unknown>
} & Pick<
    ComponentProps<typeof Table>,
    'style' | 'onTableColumnHeaderClick' | 'getColumnSorting'
>

export const TableHeaderRow: React.FC<TableHeaderRowProps> = (props) => {
    const {
        table,
        headerGroup,
        onTableColumnHeaderClick,
        getColumnSorting,
        style,
    } = props

    return (
        <tr key={headerGroup.id}>
            {headerGroup.headers.map((header, index) => {
                const { isHidden, actualHeader, ...tableHeaderCellProps } =
                    getTableHeaderCellProps(header, table)

                const sorting: SortingOrder = getColumnSorting
                    ? getColumnSorting(actualHeader)
                    : undefined

                if (isHidden) {
                    return null
                }

                return (
                    <TableHeaderCell
                        key={tableHeaderCellProps.id}
                        {...tableHeaderCellProps}
                        isSticky={index === 0}
                        onClick={() => {
                            if (actualHeader.column.getCanSort()) {
                                onTableColumnHeaderClick?.(actualHeader)
                            }
                        }}
                        sorting={sorting}
                        style={style}
                    >
                        {flexRender(
                            actualHeader.column.columnDef.header,
                            actualHeader.getContext()
                        )}
                    </TableHeaderCell>
                )
            })}
        </tr>
    )
}
